import '@agilepoint/icons-generic';
import * as React from 'react';
import { IIllustrationProps } from './types';

export const Illustration = React.memo((props: IIllustrationProps) => React.createElement('ap-illustration', props));

Illustration.displayName = 'Illustration';
